var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowIconFourteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 0H0V66H66V0Z",
    fill: "#9C9894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0006 65.9989V36.2329L46.7286 16.9609L46.0686 17.8849L40.7226 26.0689L42.2406 27.2569L42.6366 27.9829L49.1706 30.8869V34.6489L48.3126 38.8729L49.1706 43.0969C49.1706 44.7469 48.3126 45.4069 48.3126 45.4069L47.5206 45.5389L40.5246 48.5089L37.6206 48.9049L35.6406 48.1129L30.2286 49.1029L25.8066 48.5749L17.6886 45.4069L17.2926 44.9449L17.2266 45.0109L38.2806 65.9989H66.0006Z",
    fill: "#77726E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.999 18.7383C31.745 18.7383 30.755 19.5303 30.359 20.6523H19.799C19.271 20.6523 18.875 21.0483 18.875 21.5763C18.875 22.1043 19.271 22.5003 19.799 22.5003H30.359C30.755 23.6223 31.811 24.4143 32.999 24.4143C34.583 24.4143 35.837 23.1603 35.837 21.5763C35.837 20.0583 34.583 18.7383 32.999 18.7383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1094 37.7511L38.4094 45.5391L40.4554 37.2891C38.6074 37.5531 36.6934 37.6851 35.1094 37.7511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4304 36.8203C43.1664 36.8863 42.8364 36.8863 42.5724 36.9523L39.7344 48.3703L39.8004 48.5683C43.6284 47.9743 46.8624 46.9183 48.3144 45.3343L43.4304 36.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2734 36.3601L49.1014 43.0261V34.5781C48.1114 35.3701 46.7914 35.8981 45.2734 36.3601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 34.5781V43.0261L20.7186 36.3601C19.2006 35.8981 17.8806 35.3701 16.8906 34.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.061 37.75C32.995 37.75 32.995 37.75 33.061 37.75C32.995 37.75 32.995 37.75 32.995 37.75L28.375 48.574L28.441 48.904C29.959 49.036 31.477 49.102 33.061 49.102C34.579 49.102 36.163 49.036 37.681 48.904L37.747 48.574L33.061 37.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.492 37.0187C23.228 36.9527 22.898 36.9527 22.634 36.8867L17.75 45.4007C19.202 46.9847 22.436 48.0407 26.264 48.6347L26.33 48.4367L23.492 37.0187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4766 37.3516L27.5886 45.5356L30.9546 37.7476C29.3046 37.6816 27.3906 37.5496 25.4766 37.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7917 17.0863C46.3957 16.7563 45.8017 16.8223 45.4717 17.2183L37.6177 26.7883C37.3537 26.7223 37.0897 26.6563 36.7597 26.6563C35.1757 26.6563 33.9217 27.9103 33.9217 29.4943C33.9217 31.0783 35.1757 32.3323 36.7597 32.3323C38.3437 32.3323 39.5977 31.0783 39.5977 29.4943C39.5977 28.9003 39.3997 28.3723 39.1357 27.9103L46.9237 18.4063C47.2537 18.0103 47.2537 17.4163 46.7917 17.0863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1686 27.2571L41.3106 28.3131C41.4426 28.7091 41.5086 29.1051 41.5086 29.5671C41.5086 32.1411 39.3966 34.3191 36.7566 34.3191C34.1166 34.3191 32.0046 32.2071 32.0046 29.5671C32.0046 28.3791 32.4666 27.3231 33.1266 26.5311H32.9946C27.4506 26.5311 16.8906 27.5211 16.8906 31.2831C16.8906 35.0451 27.4506 36.0351 32.9946 36.0351C38.5386 36.0351 49.0986 35.0451 49.0986 31.2831C49.0986 29.1051 45.9306 27.9171 42.1686 27.2571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIconFourteen);
export default __webpack_public_path__ + "static/media/shadow-icon-fourteen.c925579d0b8eb68b55bdcf2781ecb01f.svg";
export { ForwardRef as ReactComponent };